import CurrencyAmount from '@components/currency-amount/CurrencyAmount';
import {
  isTermDisabled,
  termDisplayName
} from '@features/transactions/helpers/installmentSchedule';
import { PaymentOrderTermType } from '@types';

import InstallmentTermCardAmount from './InstallmentTermCardAmount';
import TermBreakdownTooltip, {
  shouldShowTermInstallmentAmountTooltip
} from './TermInstallmentBreakdownTooltip';

type InstallmentTermCardProps = {
  row: PaymentOrderTermType;
  index: number;
  memberId: string;
  amountSymbolClass: string;
  isDefaultCurrency: boolean;
  onAmountHoverChange: (hovered: boolean) => void;
  paymentLinkNotGenerated: boolean;
};

const InstallmentTermCard = ({
  row,
  index,
  memberId,
  amountSymbolClass,
  isDefaultCurrency,
  onAmountHoverChange,
  paymentLinkNotGenerated
}: InstallmentTermCardProps) => {
  const disabled = isTermDisabled(row);

  const rowClass = disabled
    ? 'font-normal text-cofeeNeutral8 line-through'
    : 'font-semibold text-content';
  const amountSymbolClassResolved = disabled
    ? `${amountSymbolClass} text-cofeeNeutral8 line-through`.trim()
    : amountSymbolClass;

  const amountDisplay = (
    <CurrencyAmount
      value={Number(row.amount ?? 0)}
      className="justify-end gap-0.5"
      valueClass={rowClass}
      symbolClass={amountSymbolClassResolved}
    />
  );

  const showBreakdownTooltip = shouldShowTermInstallmentAmountTooltip(
    row,
    String(row?.amount ?? 0)
  );

  return (
    <div
      className={`rounded-lg border border-cofeeNeutralInactive p-4 ${
        disabled || paymentLinkNotGenerated
          ? 'cursor-not-allowed bg-cofeeGreyBlue1'
          : 'bg-white'
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className={rowClass}>
          {termDisplayName(row.name, index, row.term_number)}
        </div>
        <div
          className="flex shrink-0 items-start gap-1.5"
          onMouseEnter={() => onAmountHoverChange(true)}
          onMouseLeave={() => onAmountHoverChange(false)}
        >
          {showBreakdownTooltip && !disabled ? (
            <TermBreakdownTooltip
              id={`installment-schedule-total-${index}`}
              row={row}
              isDefaultCurrency={isDefaultCurrency}
            >
              <span className="shrink-0 border-b border-dotted border-cofeeNeutral10">
                {amountDisplay}
              </span>
            </TermBreakdownTooltip>
          ) : (
            <span className="shrink-0">{amountDisplay}</span>
          )}
        </div>
      </div>
      <InstallmentTermCardAmount row={row} memberId={memberId} />
    </div>
  );
};

export default InstallmentTermCard;
